import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { B as Box } from "./Grid-CcQKdsgp.js";
import { useState, useRef, useEffect } from "react";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { useTabPanel, useTab, useTabList } from "@react-aria/tabs";
import { useTabListState } from "@react-stately/tabs";
import { Item } from "@react-stately/collections";
const gradientImages = {
  default: {
    image: "background-accent1",
    mdImage: ""
  },
  secondary: {
    image: "linear-gradient(321.9deg, #4A1290 -54.36%, #F9766E 12.84%, #4A1290 82.37%)",
    mdImage: "linear-gradient(269.87deg, #4A1291 0.26%, #F9766E 48.47%, #4A1290 98.36%)"
  },
  tertiary: {
    image: "linear-gradient(321.9deg, #4A1291 -54.36%, #F9766E 12.84%, #4A1290 82.37%)",
    mdImage: "linear-gradient(269.83deg, #F9766E 0.29%, #4A1290 100%)"
  },
  quaternary: {
    image: "surface-primary-grad-default",
    mdImage: ""
  }
};
const StripeWrapper = (props) => {
  const { children, variant, className, ...rest } = props;
  const selectedGradient = gradientImages[variant];
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...rest,
      bg: selectedGradient.image,
      md: {
        bg: selectedGradient.mdImage,
        ...rest.md
      },
      position: { type: "relative" },
      className,
      style: rest.style,
      children: [
        (variant === "secondary" || variant === "tertiary" || variant === "quaternary") && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              position: {
                type: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                right: 0
              },
              opacity: variant === "quaternary" ? 0.2 : 0.7,
              bg: "/noise.png",
              bgSize: "contain",
              bgRepeat: "repeat",
              className: "pointer-events-none mix-blend-soft-light"
            }
          ),
          /* @__PURE__ */ jsx(
            Box,
            {
              position: {
                type: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                right: 0
              },
              opacity: 0.1,
              bg: "/texture.png",
              bgSize: variant === "quaternary" ? 700 : 750,
              bgRepeat: "repeat",
              className: "pointer-events-none mix-blend-soft-light"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(Box, { position: { type: "relative", zIndex: 10 }, children })
      ]
    }
  );
};
const useClientPagination = function({
  renderPageLabel,
  data,
  onPageChange,
  itemsPerPage = 10
}) {
  const [page, setPage] = useState(0);
  const spreadsheetData = data;
  const totalPages = Math.ceil(spreadsheetData.length / itemsPerPage);
  const paginatedData = spreadsheetData.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );
  return {
    paginationProps: {
      totalPages,
      currentPage: page,
      onPageChange(p) {
        onPageChange == null ? void 0 : onPageChange(p);
        setPage(p);
      },
      itemsPerPage,
      renderPageLabel
    },
    paginatedData
  };
};
function Panel({
  state,
  ...rest
}) {
  var _a;
  const ref = useRef(null);
  const { tabPanelProps } = useTabPanel({}, state, ref);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
  }, [setVisible]);
  return /* @__PURE__ */ jsx(
    Flex,
    {
      ...tabPanelProps,
      ...rest,
      style: {
        ...tabPanelProps.style,
        ...rest.style
      },
      ref,
      className: `w-full transition-opacity duration-500 ${visible ? "opacity-100" : "opacity-0"}`,
      children: (_a = state.selectedItem) == null ? void 0 : _a.props.children
    }
  );
}
const Tab = function({ item, state }) {
  const { key, rendered } = item;
  const ref = useRef(null);
  const { tabProps } = useTab({ key }, state, ref);
  return /* @__PURE__ */ jsx("div", { ...tabProps, ref, className: "cursor-pointer", children: rendered });
};
const Tabs = function(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const state = useTabListState(props);
  const ref = useRef(null);
  const { tabListProps } = useTabList(props, state, ref);
  return /* @__PURE__ */ jsxs(Box, { ...props, width: (_a = props == null ? void 0 : props.width) != null ? _a : "100%", children: [
    /* @__PURE__ */ jsx(
      Flex,
      {
        ...tabListProps,
        ...props.tabListProps,
        style: {
          ...tabListProps.style
        },
        justify: (_c = (_b = props.tabListProps) == null ? void 0 : _b.justify) != null ? _c : "center",
        className: (_e = (_d = props == null ? void 0 : props.tabListProps) == null ? void 0 : _d.className) != null ? _e : "overflow-x-auto",
        ref,
        p: (_g = (_f = props == null ? void 0 : props.tabListProps) == null ? void 0 : _f.p) != null ? _g : 4,
        gap: (_i = (_h = props == null ? void 0 : props.tabListProps) == null ? void 0 : _h.gap) != null ? _i : 6,
        children: [...state.collection].map((item) => /* @__PURE__ */ jsx(Tab, { item, state }, item.key))
      }
    ),
    /* @__PURE__ */ jsx(
      Panel,
      {
        state,
        ...props.tabPanelProps
      },
      (_j = state.selectedItem) == null ? void 0 : _j.key
    )
  ] });
};
Tabs.Item = Item;
export {
  StripeWrapper as S,
  Tabs as T,
  useClientPagination as u
};
